<template>
  <nav :class="classes" class="navbar">
    <div class="navWrap">
      <div class="navbar-translate">
        <slot v-bind="slotData"></slot>
        <navbar-toggle-button
          :toggled="showMenu"
          @click.native.stop="toggle"
        ></navbar-toggle-button>
      </div>
      <div
        class="navbar-collapse collapse"
        v-click-outside="close"
        :style="menuImage ? `background: url(${menuImage}) 0% 0% / cover;` : ''"
        :class="[
          { show: showMenu },
          { 'has-image': menuImage },
          navMenuClasses
        ]"
        v-if="$slots['navbar-menu'] || $scopedSlots['navbar-menu']"
        data-color="orange"
        id="navigation"
      >
        <slot name="before-menu"></slot>
        <div class="navbar-nav test" :class="menuClasses">
          <slot name="navbar-menu" v-bind="slotData"></slot>
        </div>
        <slot name="after-menu"></slot>
      </div>
    </div>
  </nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import NavbarToggleButton from './NavbarToggleButton';
import VueScreenSize from "vue-screen-size";

let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

export default {
  name: 'navbar',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  props: {
    transparent: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'relative'
    },
    menuClasses: {
      type: [String, Object, Array]
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    paddingTop: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'white',
      validator(value) {
        return [
          'white',
          'default',
          'primary',
          'danger',
          'success',
          'warning',
          'info'
        ].includes(value);
      }
    },
    navMenuClasses: {
      type: String,
      default: ''
    },
    menuImage: {
      type: String
    },
    expand: {
      type: [String, Boolean],
      default: 'lg'
    }
  },
  provide() {
    return {
      closeNavbar: this.close
    };
  },
  components: {
    CollapseTransition,
    NavbarToggleButton
  },
  data() {
    return {
      showMenu: false,
      extraNavClasses: '',
      currentScrollValue: 0
    };
  },
  computed: {
    slotData() {
      return {
        toggle: this.toggle,
        open: this.open,
        close: this.close,
        isToggled: this.showMenu
      };
    },
    classes() {
      let color = `bg-${this.type}`;
      let navPosition = `navbar-${this.position}`;
      let colorOnScrollTransparent =
        this.colorOnScroll && this.currentScrollValue < this.colorOnScroll;

      if (this.position === 'fixed') {
        if (this.paddingTop == false) {
          navPosition = 'fixed-top';
        }
        else {
          if (this.$vssWidth < 500) {
            navPosition = 'fixed-top3';
          }
          else {
            navPosition = 'fixed-top2';
          }          
        }
      }

      return [
        { 'navbar-transparent': this.transparent || colorOnScrollTransparent },
        { [color]: !this.transparent && this.colorOnScroll === 0 },
        this.expand ? `navbar-expand-${this.expand}` : '',
        navPosition,
        this.extraNavClasses
      ];
    }
  },
  methods: {
    setNav(value) {
      let htmlClasses = document.querySelector('html').classList;
      if (value) {
        htmlClasses.add('nav-open');
      } else {
        htmlClasses.remove('nav-open');
      }
      let isOpen = htmlClasses.contains('nav-open');
      let eventToTrigger = isOpen ? 'open' : 'close';
      this.showMenu = isOpen;
      this.$emit(eventToTrigger);
    },
    toggle() {
      this.setNav(!this.showMenu);
    },
    open() {
      this.setNav(true);
    },
    close() {
      if (this.showMenu) {
        this.setNav(false);
      }
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `bg-${this.type}`;
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = '';
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    getBannerSize() {
      if (this.$vssWidth >= 700) {
        return [700, 80];
      }
      return [this.$vssWidth, this.$vssWidth / 700 * 80];
    }
  },
  mounted() {
    document.addEventListener('scroll', this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scrollListener);
  }
};
</script>
<style>
/* 리뉴얼 작업 240819 */
.navbar.bg-default {
  padding: 0;
}
.bg-default .navWrap {
  padding: 0 40px;
  border-radius: 0;
  /* filter: blur(5px);
  -webkit-filter: blur(5px); */
  backdrop-filter: blur(2px);
  /* border-bottom: 1px solid #d6d9de; */
  box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.1);
}
.navWrap {
  display: flex; align-items: center;
  width: 100%;
  padding: 0 30px;
  border-radius: 4px;
  background-color: rgba(255,255,255, 0.5);
}
.navWrap .logoWrap {
  display: block;
  width: 90px;
  margin-right: 120px;
}
.navWrap .navbar-nav {
  width: 100%; height: 90px;
  align-items: center;
  padding: 0;
}
.navbar-1 {
  display: flex; align-items: center;
  gap: 40px;
  height: 100%;
  margin: 0; padding: 0;
  border-radius: 0;
}
.navWrap .navbar-1 li {
  position: relative;
  display: flex; align-items: center;
  height: 100%;
  margin-right: 0; padding: 0 12px;
}
.navWrap .navbar-nav li a {
  padding: 0;
}
.navWrap .navbar-nav li a:hover {
  text-decoration: none;
}
.navWrap .navbar-nav p {
  margin: 0;
  color: #15151f; font-size: 16px; font-weight: 600;
  letter-spacing: -0.16px;
}
.navWrap .navbar-1 li::after {
  content:'';
  display: block;
  position: absolute; bottom: 0; left: 0;
  width: 100%;
  border-bottom: solid 4px #3402ed;  
  transform: scaleX(0);  
  transition: transform 350ms ease-in-out;
}
.navWrap .navbar-nav li:hover p {
  color: #3402ed;
  transition: all ease-in-out .2s;
}
.navWrap .navbar-nav li:hover::after {
  transform: scaleX(1); 
}
.navbar-2 {
  display: flex; align-items: center;
  margin-left: auto;
}
.navbar-right {
  display: flex; align-items: center;
  gap: 16px;
  margin: 0; padding: 0;
}
.Connect-Wallet-btn {
  display: flex; align-items: center; justify-content: center;
  line-height: 1; width: 170px; height: 40px;
  margin-left: 40px;
  color: #fff; font-size: 16px; font-weight: 600;
  border-radius: 20px; background-color: #1b62f1;
  cursor: pointer;
}
.fixed-top2 {
  position: fixed !important;
  top: 80px;
  left: 0px;
  right: 0px;
  z-index: 1030;
}
.fixed-top3 {
  position: fixed !important;
  top: 40px;
  left: 0px;
  right: 0px;
  z-index: 1030;
}

@media screen and (max-width: 991px){
  .bg-default .navWrap {
    padding: 20px;
  }
  .navWrap {
    padding: 20px;
  }
  .navbar-1 {
    flex-direction: column;
    height: auto;
  }
  .navWrap .navbar-1 li {
    height: auto;
  }
  .navWrap .navbar-1 li::after {
    display: none;
  }
  .navWrap .navbar-nav li a:hover p {
    color: #15151f;
  }
  .navbar-2 {
    flex-direction: column;
    margin: 40px auto 0;
  }
  .Connect-Wallet-btn {
    margin: 40px auto 0;
  }
  .sidebar-collapse .navbar .navbar-collapse.show .navbar-nav {
    height: 100vh;
    background: #fff;
    z-index: 1000;
  }
}

</style>
